var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-14"},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"sm":"9"}},[_c('companies-list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }